import createReactComponent from '../createReactComponent';
export default createReactComponent('coin-yen', 'IconCoinYen', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M9 12h6', key: 'svg-1' }],
  ['path', { d: 'M9 15h6', key: 'svg-2' }],
  ['path', { d: 'M9 8l3 4.5', key: 'svg-3' }],
  ['path', { d: 'M15 8l-3 4.5v4.5', key: 'svg-4' }],
]);
